/*!
 * vuejs-typography-filters v0.0.4
 * (c) 2018 Frank Flitton
 * Released under the MIT License.
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.VuejsTypographyFilters = global.VuejsTypographyFilters || {})));
}(this, (function (exports) { 'use strict';

var jsonRichText = function (Vue) {
  Vue.filter('typoJsonRichText', function (value) {
    if (!value) { return }
    return typoJsonRichText(value)
  });

  Vue.prototype.$jsonRichText = function (value) {
    return typoJsonRichText(value)
  };

  function typoJsonRichText (value) {
    return decodeURIComponent(
      value
        .replace(/\s([^\s<]+)\s*$/, '\u00A0$1')
        .replace(/\+/g, '%20')
        .trim() + ''
    )
  }
};

var lowerCase = function (Vue) {
  Vue.filter('typoLowerCase', function (value) {
    if (!value) { return }
    return typoLowerCase(value)
  });

  Vue.prototype.$typoLowerCase = function (value) {
    return typoLowerCase(value)
  };

  function typoLowerCase (value) {
    return value.toString().trim().toLowerCase()
  }
};

var smartTypeset = function (Vue) {
  Vue.filter('typoSmartTypeset', function (value) {
    if (!value) { return }
    return typoSmartTypeset(value)
  });

  Vue.prototype.$typoSmartTypeset = function (value) {
    return typoSmartTypeset(value)
  };

  function typoSmartTypeset (value) {
    // Adapted from http://www.leancrew.com/all-this/2010/11/smart-quotes-in-javascript/
    // Inspired by smartypants plugin
    return [
      [/(^|[-\u2014\s(\["])'/g, '$1\u2018'], // opening single quote
      [/'/g, '\u2019'], // closing single quote, apostrophe
      [/(^|[-\u2014/\[(\u2018\s])"/g, '$1\u201c'], // opening double quote
      [/"/g, '\u201d'], // closing double quote
      [/(\d)-(\d)/g, '$1\u2013$2'], // en dash in numerals
      [/\s?-{2,3}\s?/g, '\u2009\u2014\u2009'], // em dash
      [/\.{3}/g, '\u2026'] // ellipsis
    ].reduce(function (str, rule) {
      return str.replace.apply(str, rule)
    }, value)
  }
};

var stripTags = function (Vue) {
  Vue.filter('typoStripTags', function (value) {
    if (!value) { return }
    return typoStripTags(value)
  });

  Vue.prototype.$typoStripTags = function (value) {
    return typoStripTags(value)
  };

  function typoStripTags (value) {
    return value
      .replace(/<(?:.|\n)*?>/gm, '')
      .trim()
  }
};

var titleCase = function (Vue) {
  Vue.filter('typoTitleCase', function (value) {
    if (!value) { return }
    return typoTitleCase(value)
  });

  Vue.prototype.$typoTitleCase = function (value) {
    return typoTitleCase(value)
  };

  function typoTitleCase (value) {
    return value
      .toString()
      .trim()
      .replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
  }
};

var upperCase = function (Vue) {
  Vue.filter('typoUpperCase', function (value) {
    if (!value) { return }
    return typoUpperCase(value)
  });

  Vue.prototype.$typoUpperCase = function (value) {
    return typoUpperCase(value)
  };

  function typoUpperCase (value) {
    return value.toString().trim().toUpperCase()
  }
};

var widow = function (Vue) {
  Vue.filter('typoWidow', function (value, arg1) {
    if (!value) { return }
    return typoWidow(value, arg1)
  });

  Vue.prototype.$typoWidow = function (value, arg1) {
    return typoWidow(value, arg1)
  };

  function typoWidow (value, arg1) {
    var charLimit = Number(arg1) || -1;
    var cleanString = value.toString().trim();
    var lastWord = cleanString.split(' ');
    lastWord = cleanString[lastWord.length - 1];

    if (charLimit === -1) {
      return value.replace(/\s([^\s<]+)\s*$/, '\u00A0$1')
    } else if (lastWord.length > charLimit && charLimit !== -1) {
      return value.replace(/\s([^\s<]+)\s*$/, '\u00A0$1')
    } else {
      return value
    }
  }
};

// Individual filter export
var typoJsonRichText = {
  install: function install (Vue, options) {
    lowerCase(Vue, options);
  }
};

var typoLowerCase = {
  install: function install (Vue, options) {
    lowerCase(Vue, options);
  }
};

var typoTitleCase = {
  install: function install (Vue, options) {
    titleCase(Vue, options);
  }
};

var typoSmartTypeset = {
  install: function install (Vue, options) {
    smartTypeset(Vue, options);
  }
};

var typoStripTags = {
  install: function install (Vue, options) {
    stripTags(Vue, options);
  }
};

var typoUpperCase = {
  install: function install (Vue, options) {
    upperCase(Vue, options);
  }
};

var typoWidow = {
  install: function install (Vue, options) {
    widow(Vue, options);
  }
};

// Complete package
var VuejsTypographyFilters = {
  install: function install (Vue, options) {
    jsonRichText(Vue, options);
    lowerCase(Vue, options);
    smartTypeset(Vue, options);
    stripTags(Vue, options);
    titleCase(Vue, options);
    upperCase(Vue, options);
    widow(Vue, options);
  }
};

// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VuejsTypographyFilters);
}

// export default VuejsTypographyFilters
var version = '0.0.4';

exports.typoJsonRichText = typoJsonRichText;
exports.typoLowerCase = typoLowerCase;
exports.typoTitleCase = typoTitleCase;
exports.typoSmartTypeset = typoSmartTypeset;
exports.typoStripTags = typoStripTags;
exports.typoUpperCase = typoUpperCase;
exports.typoWidow = typoWidow;
exports['default'] = VuejsTypographyFilters;
exports.version = version;

Object.defineProperty(exports, '__esModule', { value: true });

})));
